import styled from 'styled-components';

export const CTAVisibility = styled.div`
  ${({ theme }) => theme.breakpoints.down('sm')} {
    /* NOTE: When these fade, the Hamburger icon spans to take their place. See MenuContainer.styled.ts */
    display: none;
  }
`;
